import { Injectable } from '@angular/core';

import { toFixed } from '../../../core/services/utils/numbers';
import { PedidoSearchTotal } from '../pedido-search-total';
import { PedidoItem } from '../item/pedido-item';
import { PedidoItemVolumeCalculoService } from '../item/services/pedido-item-volume-calculo.service';

@Injectable({
    providedIn: 'root'
})
export class PedidoCalculoService {

    constructor(private pedidoItemVolumeCalculoService: PedidoItemVolumeCalculoService) { }

    /** Calcula a quantidade total de pedidos */
    calcularQuantidadePedidosTotal(totais: PedidoSearchTotal[]): number {
        let quantidadePedidosTotal = 0;
        totais?.forEach(total => {
            quantidadePedidosTotal += total.quantidadePedidos ? Number(total.quantidadePedidos) : 0;
        })

        return toFixed(quantidadePedidosTotal, 0)
    }

    /** Calcula o percentual de participação da quantidade de pedidos */
    calcularPercParticipacaoQuantidadePedidos(quantidadePedidos: number, quantidadePedidosTotal: number): number {
        quantidadePedidos = quantidadePedidos && !isNaN(quantidadePedidos) ? Number(quantidadePedidos) : 0;
        quantidadePedidosTotal = quantidadePedidosTotal && !isNaN(quantidadePedidosTotal) ? Number(quantidadePedidosTotal) : 0;

        if (quantidadePedidosTotal <= 0) {
            return 0;
        }

        const perc = (quantidadePedidos / quantidadePedidosTotal) * 100;
        return toFixed(perc, 2);
    }

    /** Calcula o valor das parcelas do pedido */
    calcularValorParcelas(valorTotal, quantidadeParcelas: number): number {
        valorTotal = valorTotal && !isNaN(valorTotal) ? Number(valorTotal) : 0;
        quantidadeParcelas = quantidadeParcelas && !isNaN(quantidadeParcelas) ? Number(quantidadeParcelas) : 0;
        if (quantidadeParcelas <= 0) {
            return 0;
        }

        const valor = valorTotal / quantidadeParcelas;
        return toFixed(valor, 2);
    }

    /** Calcula a quantidade de volumes previstos para o pedido informado */
    calcularQuantidadeVolumesPrevistos(pedidoItens: PedidoItem[]): number {
        if (!pedidoItens) {
            return 0;
        }

        let quantidadeVolumesPrevistos = 0.0;
        pedidoItens.forEach(pedidoItem => {
            const result = this.pedidoItemVolumeCalculoService.calcularQuantidadeCaixaEmbarqueTotal(pedidoItem.quantidade, pedidoItem.quantidadeCaixaEmbarque);
            quantidadeVolumesPrevistos += result.quantidadeCaixaEmbarqueTotal;
        });

        quantidadeVolumesPrevistos = Math.ceil(quantidadeVolumesPrevistos);
        return toFixed(quantidadeVolumesPrevistos, 0);
    }

    /** Calcula o valor total do pedido */
    calcularValorTotal(valorItens, percDesconto: number, valorIpi: number): number {
        valorItens = valorItens && !isNaN(valorItens) ? Number(valorItens) : 0;
        percDesconto = percDesconto && !isNaN(percDesconto) ? Number(percDesconto) : 0;
        valorIpi = valorIpi && !isNaN(valorIpi) ? Number(valorIpi) : 0;

        // valor dos itens
        let valorTotal = valorItens;
        // - valor do desconto
        const valorDesconto = (valorItens * percDesconto) / 100;
        valorTotal -= valorDesconto;
        // + valor do IPI
        valorTotal += valorIpi;

        return toFixed(valorTotal, 2);
    }

}
